import { Maybe } from 'ballerina-core'
import i18next from 'i18next'
import { cmsPageParser } from './cmsPage.parser'
import { CMSPage } from './cmsPage.state'

const maxRedirects = 5
let redirectCount = 0

export const getPage = async (slug?: string): Promise<Maybe<CMSPage>> => {
  const response = await fetch(`/api/page?locale=${i18next.language}&slug=${slug || ''}`)
  try {
    const json = await response.json()
    const redirectTo = json?.redirect?.to
    if (typeof redirectTo === 'string' && redirectCount < maxRedirects) {
      redirectCount++
      // The router picks up the new URL and loads the target page itself
      window.history.replaceState({}, '', redirectTo)
      return new Promise<Maybe<CMSPage>>(() => {})
    }
    redirectCount = 0
    return cmsPageParser(json)
  } catch (e) {
    console.log(e)
    return undefined
  }
}

export const getPagePreview = async (
  bundle: string,
  nodeId: number,
  nodeRevision: number,
  token: string
): Promise<Maybe<CMSPage>> => {
  const response = await fetch(
    `/api/preview/${bundle}/${nodeId}${nodeRevision ? `/${nodeRevision}` : ''}?token=${token}`
  )
  try {
    const json = await response.json()
    return cmsPageParser(json)
  } catch (e) {
    console.log(e)
    return undefined
  }
}
